import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-button-link',
  standalone: true,
  imports: [MatIcon, MatTooltip, TranslateModule],
  templateUrl: './button-link.component.html',
  styleUrls: ['./button-link.component.scss'],
})
export class ButtonLinkComponent {
  @Input() icon: string;
  @Input() label: string;
  @Input() tooltip: string;
  @Input() loading: boolean = false;
  @Input() loadingLabel: string;
  @Input() showInfoIcon: boolean = false;

  @Output() action = new EventEmitter<void>();
  @Output() infoAction = new EventEmitter<void>();

  onAction() {
    if (!this.loading) {
      this.action.emit();
    }
  }

  onInfoAction(event: Event) {
    event.stopPropagation();
    this.infoAction.emit();
  }
}
